import { type FunctionComponent } from "react";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import { FormControl, MenuItem, Select } from "@mui/material";
import { CANCEL_REASON } from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import TextField from "@/react/core/TextField.tsx";
import { LL0 } from "@/react/core/I18nService.tsx";
import _ from "lodash";
import { typePaymentFilter } from "@/react/OrderHistoryView/OrderHistoryView.logic.tsx";

interface CancelOrderProps {
  onClose?: () => void
}

const CancelOrder: FunctionComponent<CancelOrderProps> = ({ onClose }) => {
  return (
    <div className="w-[400px] h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
      <div className="flex flex-1  px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
        <div className="flex-1 font-bold text-[16px] text-[#0051c1]">
          {LL0().deliveryManagement.whyDoYouCancelPopup()}
        </div>
        <img src="/icon-close-popup-icon--grey@2x.png" className="w-[22px] h-[22px]" alt="" onClick={onClose}/>
      </div>
      <div className="flex flex-col gap-2 p-3">
        <div className="flex flex-col gap-1">
          <div className="font-semibold text-[14px] text-[#1d1d26]">{LL0().inventory.reason()}:</div>
          <FormControl fullWidth>
            <Select
              size="small"
            >
              {CANCEL_REASON.map(r => (
                <MenuItem key={r} value={r}>{_.get(LL0().deliveryManagement, r)?.()}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="flex flex-col gap-1">
          <div className="font-semibold text-[14px] text-[#1d1d26]">{LL0().orderHistory.otherReason()}:</div>
          <TextField/>
        </div>
        <div className="flex items-center justify-center gap-1 font-bold text-[14px]">
          <div
            className="flex-1 h-8 flex items-center justify-center border border-[#1271ff] text-[#1271ff] rounded"
            ref={makeRipple}
            onClick={onClose}
          >
            Cancel
          </div>
          <div
            className="flex-1 h-8 flex items-center justify-center bg-[#1271ff] text-white rounded"
            ref={makeRipple}
          >
            OK
          </div>
        </div>
      </div>
    </div>
  )
}

export default CancelOrder;